import { Container } from "@mantine/core";
import React, { useCallback } from "react";
import { Outlet } from "react-router-dom";
import BlogContext from "../../Context/BlogContext";
import { Blog } from "../../Model/Blog.model";
import { getStaticBlogs } from "../../Services/blog.service";

function BlogsLayout() {
  const [blogs, setBlogs] = React.useState<Set<Blog>>(
    () => new Set(getStaticBlogs())
  );

  const addBlog = useCallback((_blog: any) => {
    setBlogs((currentBlogs) => {
      if (!currentBlogs) {
        return new Set([_blog]);
      }
      return new Set(currentBlogs).add(_blog);
    });
  }, []);

  const addBlogs = useCallback((_blogs: any[]) => {
    setBlogs((currentBlogs) => {
      const updatedBlogs = new Set(currentBlogs || []);
      _blogs.forEach((blog) => updatedBlogs.add(blog));
      return updatedBlogs;
    });
  }, []);

  return (
    <Container
      fluid
      px={0}
      mx={0}
    >
      <BlogContext.Provider
        value={{
          blogs: [...(blogs ? Array.from(blogs) : [])],
          isLoading: false,
          addBlog,
          addBlogs,
        }}
      >
        <Outlet />
      </BlogContext.Provider>
    </Container>
  );
}

export default BlogsLayout;
